import React, { useState, useEffect, useCallback, useRef } from 'react';
import API from '../api/api';

const HOURS_OPTIONS = [
  { label:'-- اختر --', value:'' },
  { label:'15 ساعة', value:'15', hours:15 },
  { label:'14.5 ساعة', value:'14.5', hours:14.5 },
  { label:'14 ساعة', value:'14', hours:14 },
  { label:'13.5 ساعة', value:'13.5', hours:13.5 },
  { label:'13 ساعة', value:'13', hours:13 },
  { label:'12.5 ساعة', value:'12.5', hours:12.5 },
  { label:'12 ساعة', value:'12', hours:12 },
  { label:'11.5 ساعة', value:'11.5', hours:11.5 },
  { label:'11 ساعة', value:'11', hours:11 },
  { label:'10.5 ساعة', value:'10.5', hours:10.5 },
  { label:'10 ساعة', value:'10', hours:10 },
  { label:'9.5 ساعة', value:'9.5', hours:9.5 },
  { label:'9 ساعة', value:'9', hours:9 },
  { label:'8.5 ساعة', value:'8.5', hours:8.5 },
  { label:'8 ساعة', value:'8', hours:8 },
  { label:'7.5 ساعة', value:'7.5', hours:7.5 },
  { label:'7 ساعة', value:'7', hours:7 },
  { label:'6.5 ساعة', value:'6.5', hours:6.5 },
  { label:'6 ساعة', value:'6', hours:6 },
  { label:'5.5 ساعة', value:'5.5', hours:5.5 },
  { label:'5 ساعة', value:'5', hours:5 },
  { label:'4.5 ساعة', value:'4.5', hours:4.5 },
  { label:'4 ساعة', value:'4', hours:4 },
  { label:'3.5 ساعة', value:'3.5', hours:3.5 },
  { label:'3 ساعة', value:'3', hours:3 },
  { label:'2.5 ساعة', value:'2.5', hours:2.5 },
  { label:'2 ساعة', value:'2', hours:2 },
  { label:'1.5 ساعة', value:'1.5', hours:1.5 },
  { label:'1 ساعة', value:'1', hours:1 },
  { label:'0.5 ساعة', value:'0.5', hours:0.5 },
  { label:'لم يتم التشغيل', value:'no', hours:0 },
  { label:'تعطل الغطاس', value:'broken', hours:0 },
  { label:'عيد الفطر', value:'eid_fitr', hours:0 },
  { label:'عيد الاضحى المبارك', value:'eid_adha', hours:0 },
];
const EXTRA_OPTIONS = [{ label:'لا يوجد', value:'' }, ...Array.from({length:20}, (_,i) => ({ label:`${(i+1)*0.5} ساعة`, value:`${(i+1)*0.5}` }))];
const DAYS_OPTIONS = [
  { label:'-- اختر --', value:'' },
  { label:'تشغيل يوم', value:'full', run_type:'full' },
  { label:'تشغيل نصف يوم', value:'half', run_type:'half' },
  { label:'تشغيل ربع يوم', value:'quarter', run_type:'quarter' },
  { label:'تشغيل خمس عشرة ساعة', value:'15', run_type:'hours', hours:15 },
  { label:'تشغيل أربع عشرة ساعة', value:'14', run_type:'hours', hours:14 },
  { label:'تشغيل ثلاث عشرة ساعة', value:'13', run_type:'hours', hours:13 },
  { label:'تشغيل اثنى عشرة ساعة', value:'12', run_type:'hours', hours:12 },
  { label:'تشغيل إحدى عشرة ساعة', value:'11', run_type:'hours', hours:11 },
  { label:'تشغيل عشر ساعات', value:'10', run_type:'hours', hours:10 },
  { label:'تشغيل تسع ساعات', value:'9', run_type:'hours', hours:9 },
  { label:'تشغيل ثمان ساعات', value:'8', run_type:'hours', hours:8 },
  { label:'تشغيل سبع ساعات', value:'7', run_type:'hours', hours:7 },
  { label:'تشغيل ست ساعات', value:'6', run_type:'hours', hours:6 },
  { label:'تشغيل خمس ساعات', value:'5', run_type:'hours', hours:5 },
  { label:'تشغيل أربع ساعات', value:'4', run_type:'hours', hours:4 },
  { label:'تشغيل ثلاث ساعات', value:'3', run_type:'hours', hours:3 },
  { label:'تشغيل ساعتين', value:'2', run_type:'hours', hours:2 },
  { label:'تشغيل ساعة', value:'1', run_type:'hours', hours:1 },
  { label:'لم يتم التشغيل', value:'no', run_type:'full' },
  { label:'تعطل الغطاس', value:'broken', run_type:'full' },
  { label:'عيد الفطر', value:'eid_fitr', run_type:'full' },
  { label:'عيد الأضحى المبارك', value:'eid_adha', run_type:'full' },
];
const COLORS = ['#abcaf2','#ffead1','#e8b65e','#d1ebc6','#15aaf4','#fdffa3','#d29104','#f4f5d6','#76ae6b','#f4c2c2','#c2f4e8','#e8c2f4'];
const NO_OP_VALS = ['no','broken','eid_fitr','eid_adha'];
const POSTPONE_VALS = ['broken','eid_fitr','eid_adha'];
const REASON_MAP = { no:'لم يتم التشغيل', broken:'تعطل الغطاس', eid_fitr:'عيد الفطر', eid_adha:'عيد الاضحى المبارك' };

function Schedule({ partnership, onBack }) {
  const today = new Date().toISOString().split('T')[0];
  const fmtLocalDate = (d) => `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`;
  const [fromDate, setFromDate] = useState(() => { const n=new Date(); return fmtLocalDate(new Date(n.getFullYear(), n.getMonth(), 1)); });
  const [toDate, setToDate] = useState(() => { const n=new Date(); return fmtLocalDate(new Date(n.getFullYear(), n.getMonth()+1, 0)); });
  const [data, setData] = useState(null);
  const [rows, setRows] = useState([]);
  const todayRowRef = useRef(null);
  useEffect(() => {
    if (rows.length > 0 && todayRowRef.current) {
      setTimeout(() => {
        todayRowRef.current?.scrollIntoView({ block: 'center', behavior: 'smooth' });
      }, 150);
    }
  }, [rows]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState({});
  const [error, setError] = useState('');
  const [filterPartner, setFilterPartner] = useState('');
  const [emergencyModal, setEmergencyModal] = useState(null);
  const [emergencyForm, setEmergencyForm] = useState({ partner_id:'', hours:'' });
  const [avgDayMinutes, setAvgDayMinutes] = useState(869);

  useEffect(() => {
    if (partnership.quota_type === 'days') {
      API.get(`/reports/${partnership.id}/?type=summary_all&from_date=${fromDate}&to_date=${toDate}`)
        .then(res => { if (res.data?.totals?.avg_day_minutes) setAvgDayMinutes(res.data.totals.avg_day_minutes); })
        .catch(()=>{});
    }
  }, [partnership.id, partnership.quota_type, fromDate, toDate]);

  const load = useCallback(async () => {
    setLoading(true); setError('');
    try {
      const res = await API.get(`/schedule/${partnership.id}/?from=${fromDate}&to=${toDate}`);
      setData(res.data);
      const mainRows = res.data.rows.map(r => ({
        ...r,
        emergencies: (r.is_group && r.group_member_index !== 0) ? [] : (res.data.emergency_rows || []).filter(er => er.date === r.date)
      }));
      setRows(mainRows);
    } catch(e) { setError(e.response?.data?.error || 'خطأ'); }
    setLoading(false);
  }, [partnership.id, fromDate, toDate]);

  useEffect(() => { load(); }, [load]);

  const getPartnerColor = (partnerId) => {
    const p = data?.partners?.find(p => p.id === partnerId);
    return p?.color || COLORS[0];
  };
  const getVal = (row) => {
    if (row._sel !== undefined) return row._sel;
    if (row.no_operation) {
      if (row.no_operation_reason?.includes('تعطل')) return 'broken';
      if (row.no_operation_reason?.includes('الفطر')) return 'eid_fitr';
      if (row.no_operation_reason?.includes('الاضحى') || row.no_operation_reason?.includes('الأضحى')) return 'eid_adha';
      return 'no';
    }
    // لشراكة الأيام: run_type يحدد النوع دائماً
    if (row.run_type === 'full' && !row.no_operation) return 'full';
    if (row.run_type === 'half') return 'half';
    if (row.run_type === 'quarter') return 'quarter';
    if (row.run_type === 'hours' && row.hours_actual) {
      const h = parseFloat(row.hours_actual);
      return String(Math.round(h * 10) / 10);
    }
    // لشراكة الساعات فقط
    if (!row.run_type && row.hours_actual) {
      const h = parseFloat(row.hours_actual);
      return String(Math.round(h * 10) / 10);
    }
    return '';
  };

  const handleChange = async (i, value) => {
    const row = rows[i];
    // للمجموعة الشريك الأول: إذا كان عنده no_operation وغيّر اختياره
    console.log('handleChange', value, 'is_group:', row.is_group, 'idx:', row.group_member_index, 'no_op:', row.no_operation);
    // للمجموعة الشريك الأول (من Slots) عند اختيار "لم يتم التشغيل" -> نحفظ جلسة no_operation
    const isFirstGroupMember = row.is_group && row.group_members?.length > 0 && row.group_members[0]?.id === row.partner_id;
    if (isFirstGroupMember && (value === 'no' || POSTPONE_VALS.includes(value))) {
      const partnerId = row.real_partner_id || row.partner_id;
      const isPostponeVal = POSTPONE_VALS.includes(value);
      const reason = isPostponeVal ? REASON_MAP[value] : 'لم يتم التشغيل';
      setSaving(s=>({...s,[i]:true}));
      try {
        const groupMembers = row.group_members || [];
        if (isPostponeVal) {
          await API.post(`/schedule/${partnership.id}/save/`, { date:row.date, partner_id:partnerId, real_partner_id:partnerId, run_type:'full', hours_actual:null, no_operation:true, no_operation_reason:reason, extra_hours:null, sub_partner_id:null, is_group_postpone:true });
        } else {
          for (const member of groupMembers) {
            await API.post(`/schedule/${partnership.id}/save/`, { date:row.date, partner_id:member.id, real_partner_id:member.id, run_type:'full', hours_actual:null, no_operation:true, no_operation_reason:reason, extra_hours:null, sub_partner_id:null });
          }
          if (groupMembers.length === 0) {
            await API.post(`/schedule/${partnership.id}/save/`, { date:row.date, partner_id:partnerId, real_partner_id:partnerId, run_type:'full', hours_actual:null, no_operation:true, no_operation_reason:reason, extra_hours:null, sub_partner_id:null });
          }
        }
        await load();
      } catch(e){ console.error(e); }
      setSaving(s=>({...s,[i]:false}));
      return;
    }
    // أي شريك عنده ترحيل ويغير اختياره -> نحذف الجلسة ونعيد التحميل
    if (row.is_postponed) {
      const partnerId = row.real_partner_id || row.partner_id;
      const isGroupPostpone = isFirstGroupMember && row.is_group;
      setSaving(s=>({...s,[i]:true}));
      try {
        await API.post(`/schedule/${partnership.id}/save/`, { date:row.date, partner_id:partnerId, real_partner_id:partnerId, _delete:true, is_group_postpone:isGroupPostpone });
        await load();
      } catch(e){ console.error(e); }
      setSaving(s=>({...s,[i]:false}));
      return;
    }
    // عند اختيار "اختر" نحذف الجلسة
    if (value === '') {
      const partnerId = row.real_partner_id || row.partner_id;
      setSaving(s=>({...s,[i]:true}));
      try {
        await API.post(`/schedule/${partnership.id}/save/`, { date:row.date, partner_id:partnerId, real_partner_id:partnerId, _delete:true });
        // نعيد تحميل الجدول كاملاً لأن الترحيل قد يكون تغير
        await load();
      } catch(e){ console.error(e); }
      setSaving(s=>({...s,[i]:false}));
      return;
    }
    const isDays = partnership.quota_type === 'days';
    const opt = isDays ? DAYS_OPTIONS.find(o => o.value === value) : HOURS_OPTIONS.find(o => o.value === value);
    if (!opt) return;
    const isNoOp = NO_OP_VALS.includes(value);
    const isPostpone = POSTPONE_VALS.includes(value);
    const isDaysHours = isDays && opt.run_type === 'hours';
    const isHours = !isNoOp && (!isDays || isDaysHours) && value !== '';
    const newRows = [...rows];
    newRows[i] = { ...row, _sel:value, hours_actual:isHours?opt.hours:null, no_operation:isNoOp, no_operation_reason:isNoOp?REASON_MAP[value]:'', is_postponed:isPostpone, sub_partner_id:null, extra_hours:null };
    setRows(newRows);
    if (!value) return;
    setSaving(s => ({...s, [i]:true}));
    try {
      const partnerId = row.real_partner_id || row.partner_id;
      const runTypeVal = opt.run_type || (isHours?'hours':'full');
      await API.post(`/schedule/${partnership.id}/save/`, { date:row.date, partner_id:partnerId, real_partner_id:partnerId, run_type:runTypeVal, hours_actual:isHours?opt.hours:null, no_operation:isNoOp, no_operation_reason:isNoOp?REASON_MAP[value]:'', extra_hours:null, sub_partner_id:null });
      // لشراكة الأيام: نعيد التحميل فقط لليوم/النصف/الربع لإحضار الساعات المحسوبة
      if ((isDays && !isDaysHours) || isPostpone || row.is_postponed || row.no_operation_reason) { await load(); return; }
      if (isPostpone || isNoOp) await load();
    } catch(e) { console.error(e); }
    setSaving(s => ({...s, [i]:false}));
  };

  const handleExtra = async (i, val) => {
    const newRows = [...rows];
    newRows[i] = { ...rows[i], extra_hours:val||null };
    setRows(newRows);
    const row = newRows[i];
    const pid = row.real_partner_id || row.partner_id;
    try { await API.post(`/schedule/${partnership.id}/save/`, { date:row.date, partner_id:pid, real_partner_id:pid, run_type:row.run_type||'hours', hours_actual:row.hours_actual, extra_hours:val||null, no_operation:false, no_operation_reason:'', sub_partner_id:row.sub_partner_id||null }); } catch(e) { console.error(e); }
  };

  const handleSub = async (i, subId) => {
    const newRows = [...rows];
    newRows[i] = { ...rows[i], sub_partner_id:subId||null };
    setRows(newRows);
    const row = newRows[i];
    const pid = row.real_partner_id || row.partner_id;
    try {
      await API.post(`/schedule/${partnership.id}/save/`, {
        date:row.date, partner_id:pid, real_partner_id:pid,
        sub_partner_id:subId?parseInt(subId):null,
        update_sub_only:true
      });
    } catch(e) { console.error(e); }
  };

  const deleteEmergency = async (date, partnerId) => {
    if (!window.confirm('هل تريد حذف هذا المشارك الطارئ؟')) return;
    const pid = parseInt(partnerId);
    await API.post(`/schedule/${partnership.id}/save/`, { date, partner_id:pid, real_partner_id:pid, run_type:'hours', hours_actual:null, no_operation:false, no_operation_reason:'', _delete:true });
    await load();
  };

  const handleEmergency = async () => {
    if (!emergencyForm.partner_id || !emergencyForm.hours) return;
    const row = rows[emergencyModal];
    try {
      await API.post(`/schedule/${partnership.id}/save/`, { date:row.date, partner_id:emergencyForm.partner_id, real_partner_id:emergencyForm.partner_id, run_type:'hours', hours_actual:parseFloat(emergencyForm.hours), no_operation:false, no_operation_reason:'', is_emergency:true, primary_partner_id:row.real_partner_id||row.partner_id });
      await load();
    } catch(e) { console.error(e); }
    setEmergencyModal(null);
  };

  const selStyle = (row) => {
    const v = getVal(row);
    const base = { padding:'4px', borderRadius:'4px', fontSize:'12px', width:'100%', border:'1px solid' };
    if (!v) return { ...base, borderColor:'#ddd' };
    if (POSTPONE_VALS.includes(v)) return { ...base, borderColor:'#e74c3c', background:'#ffeef0', color:'#c0392b', fontWeight:'bold' };
    if (v==='no') return { ...base, borderColor:'#e67e22', background:'#fef5e7', color:'#d35400' };
    return { ...base, borderColor:'#27ae60', background:'#f0fff4', color:'#1e8449' };
  };

  const getTotalHours = (pid) => rows.filter(r => (r.real_partner_id||r.partner_id)===pid && r.hours_actual && !r.no_operation).reduce((s,r) => s+(parseFloat(r.hours_actual)||0)+(parseFloat(r.extra_hours)||0), 0);
  const getSessionsCount = (pid) => {
    const partnerRows = rows.filter(r => (r.real_partner_id||r.partner_id)===pid);
    if (partnership.quota_type === 'days') {
      return partnerRows.reduce((sum,r) => sum + (parseFloat(r.partner_share) || 1), 0);
    }
    return partnerRows.length;
  };
  const getRowHours = (row) => row.hours_actual ? (parseFloat(row.hours_actual)||0)+(parseFloat(row.extra_hours)||0) : 0;
  const filteredRows = filterPartner ? rows.filter(r => (r.real_partner_id||r.partner_id)===parseInt(filterPartner)) : rows;

  if (error) return (<div style={{padding:'20px'}}><button onClick={onBack} style={{padding:'8px 15px',background:'#6c757d',color:'white',border:'none',borderRadius:'6px',cursor:'pointer',marginBottom:'15px'}}>رجوع</button><div style={{background:'#ffeef0',padding:'20px',borderRadius:'8px',color:'#c0392b'}}>{error}</div></div>);

  const isDaysPartnership = partnership.quota_type === 'days';
  const headers = ['#','التاريخ','اليوم', ...(isDaysPartnership?['مقدار التشغيل']:[]), 'الاسم', ...(isDaysPartnership?['نوع التشغيل']:['ساعات التشغيل']), 'ساعات إضافية','البديل','مجموع الساعات','المشارك الطارئ','ساعاته','إضافة طارئ'];
  const shareLabel = (share) => {
    if (share >= 1) return 'يوم';
    if (share >= 0.5) return 'نصف يوم';
    if (share >= 0.25) return 'ربع يوم';
    return `${share}`;
  };

  return (
    <div style={{padding:'12px'}} dir="rtl">
      <div style={{display:'flex',alignItems:'center',gap:'10px',marginBottom:'10px',flexWrap:'wrap'}}>
        {(()=>{ const usr=JSON.parse(localStorage.getItem('user')||'null'); return !usr||usr.role!=='operator'; })() && <button onClick={onBack} style={{padding:'6px 12px',background:'#6c757d',color:'white',border:'none',borderRadius:'6px',cursor:'pointer'}}>رجوع</button>}
        <h2 style={{margin:0,color:'#1e3a5f',fontSize:'16px'}}>جدول التشغيل — إدخال مباشر - {partnership.name}</h2>
        {loading && <span style={{color:'#3498db',fontSize:'12px'}}>جاري التحميل...</span>}
      </div>

      <div style={{background:'white',padding:'10px',borderRadius:'8px',boxShadow:'0 1px 4px rgba(0,0,0,0.08)',display:'flex',gap:'8px',flexWrap:'wrap',alignItems:'flex-end',marginBottom:'10px'}}>
        <div><label style={{display:'block',fontSize:'11px',fontWeight:'bold',marginBottom:'3px'}}>من</label><input type="date" value={fromDate} onChange={e=>setFromDate(e.target.value)} style={{padding:'5px',border:'1px solid #ddd',borderRadius:'4px'}}/></div>
        <div><label style={{display:'block',fontSize:'11px',fontWeight:'bold',marginBottom:'3px'}}>إلى</label><input type="date" value={toDate} onChange={e=>setToDate(e.target.value)} style={{padding:'5px',border:'1px solid #ddd',borderRadius:'4px'}}/></div>
        <div><label style={{display:'block',fontSize:'11px',fontWeight:'bold',marginBottom:'3px'}}>الشركاء</label>
          <select value={filterPartner} onChange={e=>setFilterPartner(e.target.value)} style={{padding:'5px',border:'1px solid #ddd',borderRadius:'4px',fontSize:'12px'}}>
            <option value=''>كل الشركاء</option>
            {(data?.partners||[]).map(p=><option key={p.id} value={p.id}>{p.name}</option>)}
          </select>
        </div>
        <button onClick={load} style={{padding:'6px 12px',background:'#1e3a5f',color:'white',border:'none',borderRadius:'5px',cursor:'pointer',fontSize:'12px'}}>تطبيق</button>
        <button onClick={()=>setFromDate('2026-02-04')} style={{padding:'6px 10px',background:'#3498db',color:'white',border:'none',borderRadius:'5px',cursor:'pointer',fontSize:'12px'}}>من البداية</button>
        <button onClick={()=>{const f=new Date();f.setDate(f.getDate()-7);setFromDate(f.toISOString().split('T')[0]);const t=new Date();t.setDate(t.getDate()+23);setToDate(t.toISOString().split('T')[0]);}} style={{padding:'6px 10px',background:'#27ae60',color:'white',border:'none',borderRadius:'5px',cursor:'pointer',fontSize:'12px'}}>آخر أسبوع</button>
      </div>

      <div style={{display:'flex',gap:'6px',flexWrap:'wrap',marginBottom:'10px'}}>
        {(data?.partners||[]).map(p=>{
          const isDaysPartner = partnership.quota_type === 'days';
          const usedHours=getTotalHours(p.id); const sessionsCount=getSessionsCount(p.id);
          const used = isDaysPartner ? Math.round(usedHours*60*10)/10 : usedHours;
          const quota = isDaysPartner ? Math.round(avgDayMinutes*sessionsCount) : p.quota*sessionsCount;
          // ملاحظة: لشراكة الأيام لا نضرب بـ p.quota، المقام = متوسط دقائق اليوم × عدد الجلسات فقط
          const pct=quota>0?Math.min(100,Math.round(used/quota*100)):0;
          const displayUsed = isDaysPartner ? (used/60).toFixed(2) : used.toFixed(1);
          const displayQuota = isDaysPartner ? (quota/60).toFixed(2) : quota;
          return (<div key={p.id} onClick={()=>setFilterPartner(filterPartner===String(p.id)?'':String(p.id))} style={{background:filterPartner===String(p.id)?'#dbeafe':'white',padding:'7px 10px',borderRadius:'7px',boxShadow:'0 1px 4px rgba(0,0,0,0.08)',minWidth:'120px',cursor:'pointer'}}>
            <div style={{fontSize:'11px',fontWeight:'bold',color:'#1e3a5f'}}>{p.name}</div>
            <div style={{fontSize:'11px',color:'#27ae60',margin:'2px 0'}}>{displayUsed} / {displayQuota} {partnership.quota_type==='days'?'ساعة':'ساعات'}</div>
            <div style={{background:'#eee',borderRadius:'8px',height:'4px'}}><div style={{width:`${pct}%`,background:used>quota?'#e74c3c':'#27ae60',borderRadius:'8px',height:'4px'}}></div></div>
          </div>);
        })}
      </div>

      <div style={{overflowX:'auto',boxShadow:'0 2px 8px rgba(0,0,0,0.08)',borderRadius:'8px',maxHeight:'calc(100vh - 200px)',overflowY:'auto'}}>
        <table style={{width:'100%',borderCollapse:'collapse',background:'white',minWidth:'1100px'}}>
          <thead style={{position:'sticky',top:0,zIndex:10}}>
            <tr style={{background:'#1e3a5f',color:'white'}}>
              {headers.map(h=><th key={h} style={{padding:'9px 6px',fontSize:'11px',textAlign:'right',whiteSpace:'nowrap',position:'sticky',top:0,background:'#1e3a5f'}}>{h}</th>)}
            </tr>
          </thead>
          <tbody>
            {filteredRows.map((row,i)=>{
              const origI = rows.indexOf(row);
              const isToday = row.date===today;
              const val = getVal(row);
              const isPostponeRow = row.is_postponed;
              const realPid = row.real_partner_id||row.partner_id;
              const hasRun = val&&!NO_OP_VALS.includes(val);
              const bg = isPostponeRow?'#ffeef0':isToday?'#ffcccc':hasRun?'#f0fff4':val==='no'?'#ffcccc':'#fafafa';
              const emergencies = row.emergencies || [];
              const currentSub = (data?.partners||[]).find(p=>p.id===row.sub_partner_id);

              return (
                <tr key={`${row.date}-${i}`} ref={isToday?todayRowRef:null} style={{background:bg,borderRight:isToday?'3px solid #e74c3c':isPostponeRow?'3px solid #e74c3c':''}}>
                  <td style={{padding:'5px 6px',textAlign:'center',fontSize:'11px',color:'#999'}}>{row.row_num}</td>
                  <td style={{padding:'5px 6px',fontSize:'11px',fontWeight:isToday?'bold':'normal',whiteSpace:'nowrap'}}>{isToday&&<span style={{color:'#e74c3c',fontSize:'10px'}}>◆ </span>}<span>{row.date}</span></td>
                  <td style={{padding:'5px 6px',fontSize:'11px',color:'#3498db',whiteSpace:'nowrap'}}>{row.day_name}</td>
                  {isDaysPartnership && (
                    <td style={{padding:'5px 6px',textAlign:'center',fontSize:'12px',fontWeight:'bold',color:'#8e44ad',whiteSpace:'nowrap'}}>
                      {shareLabel(parseFloat(row.partner_share)||1)}
                    </td>
                  )}
                  <td style={{padding:'5px 6px',fontSize:'11px',whiteSpace:'nowrap'}}>
                    <span>
                        {!isPostponeRow && !row.is_holiday && <span style={{background:getPartnerColor(row.real_partner_id||row.partner_id),padding:'2px 6px',borderRadius:'10px',fontSize:'11px',fontWeight:'bold'}}>{row.partner_name}</span>}
                        {row.is_holiday && !isPostponeRow && <span style={{fontSize:'11px',color:'#e67e22',fontWeight:'bold'}}>🔴 إجازة</span>}
                        {isPostponeRow&&<span style={{fontSize:'10px',color:'#e74c3c',marginRight:'4px'}}> (مؤجل)</span>}
                      </span>
                  </td>
                  <td style={{padding:'5px 6px',minWidth:'160px'}}>
                    <div style={{display:'flex',alignItems:'center',gap:'3px'}}>
                      <select value={val} onChange={e=>handleChange(origI,e.target.value)} style={selStyle(row)} disabled={row.is_holiday}>
                        {(partnership.quota_type==='days' ? DAYS_OPTIONS : HOURS_OPTIONS).filter(o => {
                          if (row.is_group && row.group_member_index > 0) {
                            return !['broken','eid_fitr','eid_adha'].includes(o.value);
                          }
                          return true;
                        }).map(o=><option key={o.value} value={o.value}>{o.label}</option>)}
                      </select>
                      {saving[origI]&&<span style={{color:'#3498db',fontSize:'10px'}}>◌</span>}
                    </div>
                  </td>
                  <td style={{padding:'5px 6px',minWidth:'90px'}}>
                    {hasRun&&!row.is_holiday&&<select value={row.extra_hours||''} onChange={e=>handleExtra(origI,e.target.value)} style={{padding:'4px',border:'1px solid #ddd',borderRadius:'4px',fontSize:'11px',width:'100%'}}>
                      {EXTRA_OPTIONS.map(o=><option key={o.value} value={o.value}>{o.label}</option>)}
                    </select>}
                  </td>
                  <td style={{padding:'5px 6px',minWidth:'140px'}}>
                    {(hasRun||row.sub_partner_id)&&!row.is_holiday?(
                      <div>
                        <select value={row.sub_partner_id||''} onChange={e=>handleSub(origI,e.target.value)} style={{padding:'4px',border:'1px solid #ddd',borderRadius:'4px',fontSize:'11px',width:'100%'}}>
                          <option value=''>— لا يوجد بديل —</option>
                          {(data?.partners||[]).filter(p=>p.id!==realPid).map(p=><option key={p.id} value={p.id}>{p.name}</option>)}
                        </select>
                        {row.sub_partner_id&&currentSub&&(
                          <span style={{display:'block',color:'#1e3a5f',fontSize:'10px',marginTop:'2px',fontWeight:'bold',background:'#dbeafe',padding:'1px 5px',borderRadius:'4px'}}>{currentSub.name}</span>
                        )}
                      </div>
                    ):<span style={{color:'#ccc',fontSize:'11px'}}>—</span>}
                  </td>
                  <td style={{padding:'5px 6px',textAlign:'center',fontSize:'12px',fontWeight:'bold',color:'#27ae60',whiteSpace:'nowrap'}}>
                    {isDaysPartnership
                      ? (() => {
                          const extra = parseFloat(row.extra_hours||0);
                          const sel = getVal(row);
                          if (!sel || ['no','broken','eid_fitr','eid_adha',''].includes(sel)) return '—';
                          if (sel==='full') return extra>0 ? `يوم + ${extra} ساعة` : 'يوم كامل';
                          if (sel==='half') return extra>0 ? `نصف يوم + ${extra} ساعة` : 'نصف يوم';
                          if (sel==='quarter') return extra>0 ? `ربع يوم + ${extra} ساعة` : 'ربع يوم';
                          const h = parseFloat(sel||0);
                          return extra>0 ? `${h+extra} ساعة` : `${sel} ساعة`;
                        })()
                      : (getRowHours(row) > 0 ? getRowHours(row).toFixed(1) : '-')
                    }
                  </td>
                  <td style={{padding:'5px 6px',minWidth:'200px'}}>
                    {emergencies.length>0?(
                      <div>
                        {emergencies.map((er,ei)=>(
                          <div key={ei} style={{display:'flex',alignItems:'center',gap:'4px',marginBottom:'3px'}}>
                            <button onClick={()=>deleteEmergency(er.date,er.partner_id)} style={{padding:'1px 5px',background:'#e74c3c',color:'white',border:'none',borderRadius:'3px',cursor:'pointer',fontSize:'10px',flexShrink:0}}>×</button>
                            <span style={{fontSize:'11px',fontWeight:'bold',color:'#c0392b',flex:1}}>{er.partner_name}</span>
                            <span style={{fontSize:'12px',fontWeight:'bold',color:'#e67e22',minWidth:'25px',textAlign:'center'}}>{parseFloat(er.hours_actual)||0}</span>
                          </div>
                        ))}
                      </div>
                    ):<span style={{color:'#ccc',fontSize:'11px'}}>—</span>}
                  </td>
                  <td style={{padding:'5px 6px',textAlign:'center'}}>
                    <span style={{color:'#ccc',fontSize:'11px'}}>—</span>
                  </td>
                  <td style={{padding:'5px 6px',textAlign:'center'}}>
                    <button onClick={()=>{setEmergencyModal(origI);setEmergencyForm({partner_id:'',hours:''}); }} style={{padding:'3px 7px',background:'#e67e22',color:'white',border:'none',borderRadius:'4px',cursor:'pointer',fontSize:'11px',whiteSpace:'nowrap'}}>+ طارئ</button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {emergencyModal!==null&&(
        <div style={{position:'fixed',top:0,left:0,right:0,bottom:0,background:'rgba(0,0,0,0.5)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:1000}}>
          <div style={{background:'white',padding:'20px',borderRadius:'10px',width:'320px',direction:'rtl'}}>
            <h3 style={{margin:'0 0 5px',color:'#1e3a5f'}}>إضافة مشارك طارئ</h3>
            {emergencyModal!==null&&rows[emergencyModal]&&<p style={{margin:'0 0 15px',fontSize:'12px',color:'#666'}}>التاريخ: {rows[emergencyModal].partner_name} - يوم {rows[emergencyModal].date}</p>}
            <label style={{display:'block',marginBottom:'4px',fontWeight:'bold',fontSize:'13px'}}>اختر المشارك الطارئ</label>
            <select value={emergencyForm.partner_id} onChange={e=>setEmergencyForm({...emergencyForm,partner_id:e.target.value})} style={{width:'100%',padding:'7px',border:'1px solid #ddd',borderRadius:'5px',marginBottom:'15px'}}>
              <option value=''>— اختر —</option>
              {(data?.partners||[]).map(p=><option key={p.id} value={p.id}>{p.name}</option>)}
            </select>
            <label style={{display:'block',marginBottom:'4px',fontWeight:'bold',fontSize:'13px'}}>عدد الساعات</label>
            <select value={emergencyForm.hours} onChange={e=>setEmergencyForm({...emergencyForm,hours:e.target.value})} style={{width:'100%',padding:'7px',border:'1px solid #ddd',borderRadius:'5px',marginBottom:'15px'}}>
              <option value=''>— اختر —</option>
              {Array.from({length:30},(_,i)=><option key={i} value={(i+1)*0.5}>{(i+1)*0.5} ساعة</option>)}
            </select>
            <div style={{display:'flex',gap:'10px'}}>
              <button onClick={()=>setEmergencyModal(null)} style={{flex:1,padding:'8px',background:'#e74c3c',color:'white',border:'none',borderRadius:'5px',cursor:'pointer'}}>إلغاء</button>
              <button onClick={handleEmergency} style={{flex:1,padding:'8px',background:'#27ae60',color:'white',border:'none',borderRadius:'5px',cursor:'pointer'}}>حفظ</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Schedule;
